
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getMyProposals, delete_bid, update_offer_freelancer, updateClientInvitation, SendCounterOffer } from '../../Apis/index';
import { Await } from 'react-router-dom';

export const GetProposals = createAsyncThunk('GetProposals', async ({ formData, token }, { rejectWithValue }) => {

    try {
        const response = await getMyProposals(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});




export const WithdrawBid = createAsyncThunk('WithdrawBid', async ({ formData, token }, { rejectWithValue }) => {

    try {
        const response = await delete_bid(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


export const OfferUpdate = createAsyncThunk('OfferUpdate', async ({ formData, token }, { rejectWithValue }) => {

    try {
        const response = await update_offer_freelancer(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const InvitationUpdate = createAsyncThunk("invitationUpdate", async ({formData,token},{rejectWithValue})=>{
    try {
        const response = await updateClientInvitation(formData,token) ;
        return response
        
    } catch (error) {
        return rejectWithValue(error.response)
    }
})
export const sendCounterOffer = createAsyncThunk("sendCounterOffer",async({token,formData},{rejectWithValue})=>{
    try {
        const response = await SendCounterOffer(token,formData);
        return response.data
    } catch (error) {
        return rejectWithValue(error.response.messages)
    }
})


const freelancerProposalSlice = createSlice({
    name: 'freelanceProposal',
    initialState: {
        error: null,
        success: false,
        data: [],

        error1: null,
        success1: false,

    },
    reducers: {
        clearFreelancerProStatus: state => {
            state.success = false;
            state.error = null;
            state.success1 = false;
            state.error1 = null;
        },

        Emptytab: state => {
            state.data = [];

        }
    },
    extraReducers: builder => {
        builder
            .addCase(GetProposals.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetProposals.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(GetProposals.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })

            .addCase(WithdrawBid.pending, state => {
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(WithdrawBid.fulfilled, (state, action) => {
                state.success1 = action.payload;
                state.error1 = null;
            })
            .addCase(WithdrawBid.rejected, (state, action) => {
                state.error1 = action.payload;
                state.success1 = false;
            })
            .addCase(OfferUpdate.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(OfferUpdate.fulfilled, (state, action) => {
                state.success1 = action.payload;
                state.error1 = null;
            })
            .addCase(OfferUpdate.rejected, (state, action) => {
                state.error1 = action.payload;
                state.success1 = false;
            })
            .addCase(InvitationUpdate.pending, state => {
                state.error1 = null;
                state.success1 = false
            })
            .addCase(InvitationUpdate.fulfilled, (state,action)=>{
                state.success1 =action.payload;
                state.error1 = null;

            })
            .addCase(InvitationUpdate.rejected,(state,action)=>{
                state.success1 = false;
                state.error1 = action.payload
            })
             .addCase(sendCounterOffer.pending, state =>{
              state.success = false;
              state.error = null
        })
        .addCase(sendCounterOffer.fulfilled, (state,action)=>{
            state.success = true;
            state.data = action.payload;
            state.error = null
        })
        .addCase(sendCounterOffer.rejected,(state,action)=>{
            state.success = false;
            state.error = action.payload
        })
            
    },

});
export const { clearFreelancerProStatus, Emptytab } = freelancerProposalSlice.actions;
export default freelancerProposalSlice.reducer;

